import {
  HTTP
} from '@/http'

export default class SecurityService {

  changePassword(password) {
    return HTTP.put(`security/password`, {
      password: password
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/SecurityService.js